(() => {
  const configNode = document.getElementById('GraniteMinimumConfig');
  if (!configNode) return;
  const config = JSON.parse(configNode.textContent);
  let latest = 0;
  let checking = false;
  const evaluate = cart => {
    let count = 0, sampleCount = 0, invalid = false;
    for (const item of cart.items || []) {
      if (String(item.product_id) === String(config.sampleProductId)) {
        sampleCount += Number(item.quantity) || 0;
        if (!String(item.properties?.['Print 1'] || '').trim() || !String(item.properties?.['Print 2'] || '').trim()) invalid = true;
      } else { count += Number(item.quantity) || 0; }
    }
    const empty = !(cart.items || []).length;
    return {count, sampleCount, tooManySamples: sampleCount > 1, invalid, empty, blocked: empty || invalid || sampleCount > 1 || (count > 0 && count < 30)};
  };
  const buttons = () => document.querySelectorAll('button[name="checkout"], input[name="checkout"]');
  const render = state => {
    buttons().forEach(button => { button.disabled = state.blocked; button.removeAttribute('aria-busy'); });
    const message = state.tooManySamples ? config.sample_limit : state.invalid ? config.invalid_sample : state.empty ? config.empty
      : state.count === 0 ? config.sample : state.count < 30
      ? config.remaining.replace('__COUNT__', String(30 - state.count)) : config.ready;
    document.querySelectorAll('[data-granite-minimum]').forEach(notice => {
      notice.dataset.printCount = String(state.count);
      notice.dataset.invalidSample = String(state.invalid);
      notice.dataset.sampleCount = String(state.sampleCount);
      notice.querySelector('[data-minimum-progress]').hidden = state.count === 0;
      notice.querySelector('[data-minimum-progress]').textContent = config.progress.replace('__COUNT__', String(state.count));
      notice.querySelector('[data-minimum-message]').textContent = message;
      notice.querySelector('[data-minimum-sample-link]').hidden = !state.invalid;
    });
  };
  const readCart = async () => {
    const response = await fetch(config.cartUrl, {credentials:'same-origin', cache:'no-store', headers:{Accept:'application/json'}});
    if (!response.ok) throw new Error('Cart unavailable');
    return evaluate(await response.json());
  };
  const fail = () => {
    buttons().forEach(button => { button.disabled = false; button.removeAttribute('aria-busy'); });
    document.querySelectorAll('[data-minimum-message]').forEach(node => {node.textContent = config.error;});
  };
  const refresh = async () => {
    const version = ++latest;
    try { const state = await readCart(); if (version === latest && !checking) render(state); }
    catch { /* The Liquid-rendered rule remains in place until the next checkout check. */ }
  };
  const checkAndGo = async () => {
    if (checking) return;
    checking = true;
    ++latest;
    buttons().forEach(button => {button.disabled = true; button.setAttribute('aria-busy','true');});
    document.querySelectorAll('[data-minimum-message]').forEach(node => {node.textContent = config.checking;});
    try {
      if (window.GranitePurchaseOrder) await window.GranitePurchaseOrder.saveForCheckout();
      const state = await readCart();
      render(state);
      if (!state.blocked) location.assign(config.checkoutUrl);
      else {
        const notice = document.querySelector('[data-granite-minimum]');
        if (notice) notice.scrollIntoView({block:'center',behavior:'auto'});
        else location.assign(config.cartPage);
      }
    } catch { fail(); }
    finally { checking = false; }
  };
  const checkoutAnchor = element => {
    const link = element.closest('a[href]');
    if (!link) return false;
    try {
      const url = new URL(link.href, location.origin);
      return url.origin === location.origin && /\/checkouts?(\/|$)/.test(url.pathname);
    } catch { return false; }
  };
  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    if (event.target.closest('button[name="checkout"],input[name="checkout"]') || checkoutAnchor(event.target)) {
      event.preventDefault(); event.stopImmediatePropagation(); checkAndGo();
    }
  }, true);
  document.addEventListener('submit', event => {
    const form = event.target;
    const target = event.submitter;
    let direct = false;
    try { direct = /\/checkouts?(\/|$)/.test(new URL(form.action, location.origin).pathname); } catch {}
    if (target?.name === 'checkout' || direct) {
      event.preventDefault(); event.stopImmediatePropagation(); checkAndGo();
    }
  }, true);
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, refresh);
  }
  window.addEventListener('pageshow', refresh);
})();
